import React, { } from 'react';
import { DriveInfo as DriveInfoView } from 'components/views/organisms/DriveInfo';
import { useVehicleControllerStatus } from 'services/useVehicleControllerStatus';
import { useVehicleStatus } from 'services/useVehicleStatus';
import { Project } from 'core/models/project';
import { Vehicle } from 'core/models/vehicle';

export type DriveInfoProps = {
    className?: string;
    vehicleId: Vehicle.Id;
    projectId: Project.Id;
}

export const DriveInfo = (props: DriveInfoProps) => {
    const controllerStatus = useVehicleControllerStatus();
    const { steering } = useVehicleStatus(props.vehicleId, props.projectId);

    const _props = {
        steeringPosition: steering,
        controllerSteeringPosition: controllerStatus.steering,
        controllerAccel: controllerStatus.accel,
        controllerBrake: controllerStatus.brake,
    };

    return (
        <DriveInfoView className={props.className} {..._props} />
    );
};
